const IS_DEV = process.env.NODE_ENV !== 'development' ? false : false; // true : backup, false: production
export const IMAGE_BASE_URL = IS_DEV
  ? 'http://192.168.1.100:8000/upload'
  : 'https://api.pos-app.net/upload';
export const API_URL_BASE = IS_DEV
  ? 'http://192.168.1.100:8000/api'
  : 'https://api.pos-app.net/api';
export const IMAGE_BASE_URL_OF_USER = IS_DEV
  ? 'http://192.168.1.100:8000/upload'
  : 'https://cdn.pos-app.net/upload';
export const IMAGE_BASE_URL_OF_USER_RANK = IS_DEV
  ? 'http://192.168.1.100:8000/upload'
  : 'https://api.pos-app.net/upload';

export const ENCODE_SECRET_KEY = process.env?.ENCODE_SECRET_KEY || 'QiLCJhbGciOiJSUzI';

export const SOCKET_SERVER = IS_DEV ? 'http://127.0.0.1:8888' : 'https://realtime.pos-app.net';
